export function useLighthouse() {
  const event = useRequestEvent()
  const commonStore = useCommonStore()
  if (event?.context?.isLighthouseBot) {
    commonStore.setIsLighthouseBot(true)
  }
  return {
    isLighthouseBot: commonStore.isLighthouseBot
  }
}
